import { Component, PLATFORM_ID, inject } from "@angular/core";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { assetsConst } from "src/app/core/const/assets.const";
import { TranslateModule } from "@ngx-translate/core";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "src/app/core/services/auth.service";
import { MatMenuModule } from "@angular/material/menu";
import { ProfileDetails } from "src/app/models/authmodel";
import { Subject, Subscription, takeUntil } from "rxjs";
import { environment } from "src/environments/environment";
import { LoginComponent } from "src/app/modals/login/login.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "megastore-footer",
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule, MatMenuModule],
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  assetsConst = assetsConst;
  homeSelected = true;
  accountSelected = false;
  orderSelected = false;
  CatgySelected = false;
  wishSelected = false;
  profileDetails: ProfileDetails | null = null;
  subscriptionSubject$!: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();
  private platFormId = inject(PLATFORM_ID);
  isSignedIn = false;

  constructor(
    private _authService: AuthService,
    private dialog: MatDialog,
    public router: Router
  ) {
    this.subscribeToProfileDetails();
  }

  // TODO: check if user is logged in or not from observable. For now checking from local storage.
  LoginModal(): void {
    const isLoggedIn = localStorage.getItem(environment.storageKey);
    if (isLoggedIn) {
      this.router.navigate(["/view-profile/profile"]);
    } else {
      this.dialog
        .open(LoginComponent, {
          panelClass: ["modall", "login_nodal"],
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            console.log("sdfsfdsf", res);
          }
        });
    }
  }

  addClasstospecific(type: string): void {
    switch (type) {
      case "home":
        this.accountSelected = false;
        this.orderSelected = false;
        this.CatgySelected = false;
        this.wishSelected = false;
        this._authService.classMobile.next(false);
        this.homeSelected = true;
        break;
      case "categories":
        this.accountSelected = false;
        this.orderSelected = false;
        this._authService.classMobile.next(true);
        this.CatgySelected = true;
        this.wishSelected = false;
        this.homeSelected = false;
        break;
      case "orders":
        this.accountSelected = false;
        this.orderSelected = true;
        this.CatgySelected = false;
        this.wishSelected = false;
        this.homeSelected = false;
        this._authService.classMobile.next(false);
        break;
      case "wishlist":
        this.accountSelected = false;
        this.orderSelected = false;
        this._authService.classMobile.next(false);
        this.CatgySelected = false;
        this.wishSelected = true;
        this.homeSelected = false;
        break;
      case "account":
        this.accountSelected = true;
        this.orderSelected = false;
        this._authService.classMobile.next(false);
        this.CatgySelected = false;
        this.wishSelected = false;
        this.homeSelected = false;
        break;
    }
  }

  openUrl(url: string): void {
    window.open(url, "_blank");
  }

  private subscribeToProfileDetails(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ProfileDetails | null) => {
        if (isPlatformBrowser(this.platFormId)) {
          const checkSession = sessionStorage.getItem(
            environment.guestTokenKey
          );
          if (res !== null) {
            this.isSignedIn = true;
            this.profileDetails = res;
          } else if (checkSession) {
            this.isSignedIn = false;
          } else if (!checkSession && res === null) {
            this.isSignedIn = true;
          }
        }
      });
  }
}
